
export const useLoading = (isLoad) => {
  if (import.meta.client) {
    if (isLoad) {
      document.getElementsByClassName('loading_dialog')[0].style.display = 'block';

    } else {
      document.getElementsByClassName('loading_dialog')[0].style.display = 'none';
    }
  }
  return isLoad
}
